<template>
  <div class="newsView-box">
    <div class="newsView-wrap inner">
      <div class="posite posite1">
        <ul class="posite-menu"></ul>
         <div class="posite-map posite-map1">
          <span><i class="iconfont">&#xe65e;</i>当前位置：</span>
          <router-link to="/">首页</router-link>
          <b>></b>
           <router-link to="/jzxinwendongtai">新闻动态</router-link>
          <b>></b>
          <router-link to="/jzzhongxinxinwen">{{names}}</router-link>
          <b>></b>
          <span>详情</span>
        </div>
      </div>
      <div class="news-views">
        <div class="news-prev-box">
          <div class="news-prev-list">
            <div class="news-prev-btns" @click="handPrevpage(viewData.pre_cid)">
              <b class="iconfont">&#xe96e;</b>
              <span>上一篇</span>
            </div>
            <div class="news-prev-btns">
              <a href="javascript:;" @click="newsBack()">
                <b class="iconfont">&#xe678;</b>
                <span>返回列表</span>
              </a>
            </div>
            <div class="news-prev-btns" @click="handPrevpage(viewData.next_cid)">
              <b class="iconfont">&#xe63c;</b>
              <span>下一篇</span>
            </div>
          </div>
        </div>
        <div class="news-v">
          <div class="news-v-wrap">
            <div class="news-v-top">
              <strong>{{viewData.title}}</strong>
              <div class="news-v-time">
                <span>发布时间：{{viewData.create_time | timeFormat('yy年mm月dd日')}}</span>
                <span>来源: {{viewData.resource}}</span>
                <!-- <span>浏览次数: {{viewData.hits}}</span> -->
              </div>
            </div>
            <div class="news-v-info" v-html="viewData.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: this.title,
      meta: [{
        name: 'keyWords',
        content: this.keyWords
      },
      {
        name: 'description',
        content: this.description
      }]
    }
  },
  data () {
    return {
      viewData: {},
      cild: 0,
      names: '',
      title: '',
      keyWords: '',
      description: ''
    }
  },
  methods: {
    async getData () {
      const { data: res } = await this.$http.get(`/fdata/article_show?cid=${this.cild}`)
      if (res.code === 1) {
        this.viewData = res.data
        this.title = this.viewData.seotitle
        this.keyWords = this.viewData.seokeywords
        this.description = this.viewData.seodescription
      }
      this.names = this.$route.query.name
    },
    handPrevpage (cild) {
      this.cild = cild
      this.getData()
      // if (this.viewData.pre_title == '没有了') {
      //   this.$message.error('上一篇没有了')
      // }
      // if (this.viewData.next_title == '没有了') {
      //   this.$message.error('下一篇没有了')
      // }
    },
    newsBack () {
      this.$router.go(-1)
    }
  },
  mounted () {
    this.cild = Number(this.$route.query.cid)
    this.getData()
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/common/index.less");
@import url("@/assets/css/news/index.less");
</style>
